import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFCheckBoxInput } from "src/components/Shared/NewForms/NFCheckBoxInput";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const CustomerInvoicesDetailAdditional = ({}) => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("CreatedDate")} fieldName={t("createdDate")} required={true} disabled />
        </Col>
        <Col sm={6}>
          <NFCheckBoxInput title={t("PriceIncludesVAT")} fieldName="priceIncludesVat" />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("CreatedUser")} fieldName={"createdUser"} disabled={true} />
        </Col>
      </Row>
    </>
  );
};
